import gsap from "gsap";
import * as d3 from 'd3';

export function initAnimations() {



        const combineBalls = document.querySelector("#anim-balls-combine");
        if (combineBalls) {
            // Target the circles using their classes
            const circle1 = combineBalls.querySelector(".circle-1");
            const circle2 = combineBalls.querySelector(".circle-2");
            const circle3 = combineBalls.querySelector(".circle-3");
            const circle4 = combineBalls.querySelector(".circle-4");
            const circle2wrap = combineBalls.querySelector(".circle-2-wrapper");
            const circle3wrap = combineBalls.querySelector(".circle-3-wrapper");

            const leftX = 249;
            const rightX = 482;
            const centralX = 365;

            const tl = gsap.timeline();

            // Add animations to the timeline
            tl.set([circle1, circle2, circle3, circle4], {
                    transformOrigin: "50% 50%",
                })
                .to([circle1, circle2], {
                    attr: { cx: leftX },
                    duration: 0.8,
                    ease: "power3.inOut"
                })
                .to([circle3, circle4], {
                    attr: { cx: rightX },
                    duration: 0.8,
                    ease: "power3.inOut"
                }, "-=0.8")
                .set([circle1, circle4], {
                    opacity: 0
                })
                .to([circle1, circle2, circle3, circle4], {
                    attr: { r: 40 },
                    duration: 0.5,
                    ease: "power3.inOut"
                }, "-=0.5")

                .to([circle2, circle3], {
                    attr: { cx: centralX },
                    duration: 0.8,
                    ease: "power3.inOut"
                })
                .to([circle2, circle3], {
                    attr: { r: 60 },
                    duration: 0.5,
                    ease: "power3.inOut"
                }, "-=0.5")


            tl.play();


        }


        const newtonSVG = document.querySelector("#anim-newton");
        if (newtonSVG) {

            const tl = gsap.timeline({ repeat: -1 });

            // Animate left ball
            tl.to("#newton-ball-left", {
                    onStart: function() { gsap.set(this.targets(), { fill: "#FCC32D" }); },
                    motionPath: {
                        path: "#newton-path-left",
                        align: "#newton-path-left",
                        autoRotate: true,
                        alignOrigin: [0.5, 0.5]
                    },
                    duration: 0.45,
                    ease: "power3.out",
                })
                .to("#newton-ball-left", {
                    onComplete: function() { gsap.set(this.targets(), { fill: "#20503A" }); },
                    motionPath: {
                        path: "#newton-path-left",
                        align: "#newton-path-left",
                        autoRotate: true,
                        alignOrigin: [0.5, 0.5],
                        start: 1,
                        end: 0
                    },
                    duration: 0.45,
                    ease: "power3.in"
                }); // Add a delay if needed

            // Animate right ball
            tl.to("#newton-ball-right", {
                    onStart: function() { gsap.set(this.targets(), { fill: "#FCC32D" }); },
                    motionPath: {
                        path: "#newton-path-right",
                        align: "#newton-path-right",
                        autoRotate: true,
                        alignOrigin: [0.5, 0.5]
                    },
                    duration: 0.45,
                    ease: "power3.out",
                })
                .to("#newton-ball-right", {
                    onComplete: function() { gsap.set(this.targets(), { fill: "#20503A" }); },
                    motionPath: {
                        path: "#newton-path-right",
                        align: "#newton-path-right",
                        autoRotate: true,
                        alignOrigin: [0.5, 0.5],
                        start: 1,
                        end: 0
                    },
                    duration: 0.45,
                    ease: "power3.in"
                });

        }




        const pulseCircles = document.querySelector("#anim-circles-pulse");
        if (pulseCircles) {


            gsap.set("#anim-circles-pulse .pulse", {
                scale: 0,
                transformOrigin: "center center"
            });

            var tl = gsap.timeline({ repeat: -1 });

            tl.to("#anim-circles-pulse .pulse", {
                scale: 1,
                opacity: 0,
                duration: 12,
                ease: "power1.inOut",
                stagger: {
                    each: 0.84,
                    repeat: -1
                }
            });

            tl.progress(0.5);

        }






        const growCircles = document.querySelector("#anim-circles-inflate");
        if (growCircles) {


            // Select all circle elements from the SVG
            const circles = document.querySelectorAll('#anim-circles-inflate circle');

            // Function to shuffle an array
            function shuffle(array) {
                let currentIndex = array.length,
                    temporaryValue, randomIndex;

                // While there remain elements to shuffle...
                while (0 !== currentIndex) {

                    // Pick a remaining element...
                    randomIndex = Math.floor(Math.random() * currentIndex);
                    currentIndex -= 1;

                    // And swap it with the current element.
                    temporaryValue = array[currentIndex];
                    array[currentIndex] = array[randomIndex];
                    array[randomIndex] = temporaryValue;
                }

                return array;
            }

            // Shuffle the circles array
            const shuffledCircles = shuffle(Array.from(circles));

            // Create a GSAP timeline
            const tl = gsap.timeline({ defaults: { duration: 1, ease: "bounce.out" } });

            // Scale up each circle with a staggered timing
            tl.to(shuffledCircles, { scale: 2.5, transformOrigin: "center center", stagger: 0.075 });

        }


        const methodAnimWrapper = document.querySelector(".method-anim-wrapper");
        const methodAnim = document.querySelector("#method-steps");
        const methodAnimHeading = document.querySelector(".page-heading #method-steps");

        if (methodAnimWrapper) {

            let tl;

            if (methodAnimHeading) {
                tl = gsap.timeline();

            } else {
                tl = gsap.timeline({
                    // Adding ScrollTrigger to the timeline
                    scrollTrigger: {
                        trigger: methodAnim,
                        start: "bottom bottom",
                        toggleActions: "play none none none",
                    }
                });

            };

            // Animate method-step-1 (square)
            const square = document.querySelector('#method-step-1');
            const hex = document.querySelector('#method-step-2');
            const circle = document.querySelector('#method-step-3');
            const all = document.querySelector('#method-steps');

            gsap.set(square, {
                x: '-200%'
            });
            gsap.set(circle, {
                x: '170%'
            });

            tl.fromTo(square, { autoAlpha: 0.25 }, {
                duration: 0.35,
                autoAlpha: 1,
                ease: "power1.inOut"
            });
            tl.fromTo(hex, { autoAlpha: 0.25 }, {
                duration: 0.35,
                autoAlpha: 1,
                ease: "power1.inOut"
            }, "-=0.1");
            tl.fromTo(circle, { autoAlpha: 0.25 }, {
                duration: 0.35,
                autoAlpha: 1,
                ease: "power1.inOut"
            }, "-=0.1");

            tl.to(square, {
                delay: 1.2,
                duration: 0.9,
                x: '0',
                scale: 1.1,
                ease: "power4",
                transformOrigin: "center"
            }, 0);

            tl.to(circle, {
                delay: 1.2,
                duration: 0.9,
                x: '0',
                ease: "power4",
                transformOrigin: "center"
            }, 0);

            tl.to("#method-step-2", {
                duration: 0.75,
                ease: "back.out",
                scale: 0.675,
                transformOrigin: "center"
            }, "-=0.65");

            tl.to("#method-step-3", {
                duration: 0.8,
                ease: "back.out",
                scale: 0.4,
                transformOrigin: "center"
            }, "-=0.8");

            tl.to(all, {
                duration: 0.5,
                scale: 1.5,
                ease: "back.out",
                transformOrigin: "center"
            }, "-=0.25");

        }




        const teamCircles = d3.select("#anim-circles-team");

        if (teamCircles) {
            function randomPosition() {
                const svgWidth = 730;
                const svgHeight = 440;
                const circleRadius = 40;
                const x = Math.random() * (svgWidth - circleRadius * 2) + circleRadius;
                const y = Math.random() * (svgHeight - circleRadius * 2) + circleRadius;
                return { x, y };
            }

            function animateCircle(circle) {
                const newPosition = randomPosition();
                const duration = Math.random() * 3 + 1; // Random duration between 1 and 4 seconds

                circle.transition()
                    .duration(duration * 750) // Convert seconds to milliseconds
                    .ease(d3.easeQuadInOut)
                    .attr("cx", newPosition.x)
                    .attr("cy", newPosition.y)
                    .on("end", function() {
                        animateCircle(d3.select(this));
                    });
            }

            teamCircles.selectAll("circle")
                .each(function() {
                    animateCircle(d3.select(this));
                });

        }









        const serviceCircles = d3.select("#anim-purpose-services");

        if (serviceCircles) {
            const diagram = document.querySelector(".purpose-diagram");

            function randomPosition(circleRadius) {
                const diagramRect = diagram.getBoundingClientRect();
                const x = Math.random() * (diagramRect.width - circleRadius * 2) + circleRadius;
                const y = Math.random() * (diagramRect.height - circleRadius * 2) + circleRadius;
                return { x, y };
            }

            function animateCircle(circle, initial = false) {
                const circleRadius = circle.offsetWidth / 2; // Assuming the circle is styled to be circular
                const newPosition = randomPosition(circleRadius);
                let duration;

                if (initial) {
                    // Set a quicker initial duration for the first movement
                    duration = 0; // Quick 0.5 second animation to start
                } else {
                    // Then use random duration for subsequent animations
                    duration = Math.random() * 7 + 5; // Random duration between 1 and 4 seconds
                }

                // Calculate translate values, considering the circle's initial position at the center
                const translateX = newPosition.x - circleRadius;
                const translateY = newPosition.y - circleRadius;

                // Apply the CSS transitions using transform
                circle.style.transition = `transform ${duration}s ease-in-out`;
                circle.style.transform = `translate(${translateX}px, ${translateY}px)`;

                // Recursive call with a timeout for the next animation cycle
                setTimeout(function() {
                    animateCircle(circle); // After the initial quick start, proceed with random timing
                }, duration * 1000); // Convert seconds to milliseconds for setTimeout
            }

            const circles = document.querySelectorAll(".purpose-diagram__circle");

            circles.forEach(circle => {
                animateCircle(circle, true); // Start each circle with the quicker initial animation
            });


        }






        // Function to check if purposeLines element exists every 100ms
        const checkPurposeLinesExistence = setInterval(() => {
            const purposeLines = document.querySelector(".purpose #purpose-lines");
            if (purposeLines) {
                clearInterval(checkPurposeLinesExistence); // Stop checking once purposeLines exists

                const svg = d3.select('#purpose-lines');
                const circle = svg.select('circle');
                const lines = svg.selectAll('line');

                // Function to calculate the angle between two points
                function calculateAngle(x1, y1, x2, y2) {
                    const dx = x2 - x1;
                    const dy = y2 - y1;
                    const theta = Math.atan2(dy, dx); // range (-PI, PI]
                    return theta * 180 / Math.PI; // rads to degs
                }

                // Set initial positions of the lines to face the circle
                function setInitialLinePositions() {
                    const circleCX = parseFloat(circle.attr('cx'));
                    const circleCY = parseFloat(circle.attr('cy'));

                    lines.each(function() {
                        const line = d3.select(this);
                        const bbox = this.getBBox();
                        const lineCenterX = bbox.x + bbox.width / 2;
                        const lineCenterY = bbox.y + bbox.height / 2;

                        // Calculate the initial angle from the line to the circle
                        const angle = calculateAngle(lineCenterX, lineCenterY, circleCX, circleCY);

                        // Set the transform-origin and initial rotation for each line
                        line.style('transform-origin', `${lineCenterX}px ${lineCenterY}px`)
                            .style('transform', `rotate(${angle}deg)`);
                    });
                }

                // Call this function to set initial positions
                setInitialLinePositions();

                // Create a GSAP timeline with ScrollTrigger for the animation
                let tl = gsap.timeline({
                    scrollTrigger: {
                        trigger: "#purpose-lines",
                        start: "bottom bottom",
                        toggleActions: "play none none none",
                    }
                });

                // Animate the circle's cx attribute from right to left
                tl.to(circle.node(), {
                    attr: { cx: 100 },
                    duration: 3, // Adjust duration as needed
                    ease: "power3.out",
                    onUpdate: function() {
                        const circleCX = parseFloat(circle.attr('cx'));
                        const circleCY = parseFloat(circle.attr('cy'));

                        lines.each(function() {
                            const line = d3.select(this);
                            const bbox = this.getBBox();
                            const lineCenterX = bbox.x + bbox.width / 2;
                            const lineCenterY = bbox.y + bbox.height / 2;

                            // Update the angle from the line to the circle during animation
                            const angle = calculateAngle(lineCenterX, lineCenterY, circleCX, circleCY);

                            // Update the transform-origin and rotation for each line
                            line.style('transform-origin', `${lineCenterX}px ${lineCenterY}px`)
                                .style('transform', `rotate(${angle}deg)`);
                        });
                    }
                });
            }
        }, 100);


        const purposeDiagram = document.querySelector("#purpose-diagram");
        if (purposeDiagram) {

            // Create a timeline
            let tl = gsap.timeline({
                scrollTrigger: {
                    trigger: "#purpose-diagram",
                    start: "bottom bottom", // Start the animation when the top of the SVG reaches the center of the viewport
                    toggleActions: "play none none none"
                },
                defaults: { duration: 0.25 } // Default duration for each animation, can be overridden
            });

            // Set initial visibility
            gsap.set("#purpose-diagram #word-1, #purpose-diagram #word-2, #purpose-diagram #word-3, #purpose-diagram #heading", { opacity: 0, y: '-20' });
            gsap.set("#purpose-diagram #arrow-1, #purpose-diagram #arrow-2, #purpose-diagram #arrow-3", { opacity: 0.1 });

            // Add animations to the timeline
            tl
                .to("#purpose-diagram #word-1", { opacity: 1, y: '0' })
                .to("#purpose-diagram #arrow-1", { opacity: 1 }, "+=0.3")

                .to("#purpose-diagram #word-2", { opacity: 1, y: '0' }, "+=0.1")
                .to("#purpose-diagram #arrow-2", { opacity: 1 }, "+=0.3")

                .to("#purpose-diagram #word-3", { opacity: 1, y: '0' }, "+=0.1")
                .to("#purpose-diagram #arrow-3", { opacity: 1 }, "+=0.3")

                .to("#purpose-diagram #heading", { opacity: 1, y: '0' }, "+=0.5");

        }







        const teamSelector = document.querySelector(".team-selector-illustration");
        if (teamSelector) {



            gsap.set(".sub-circles circle", { transformOrigin: "50% 50%" });


            function animateCircles() {
                var tl = gsap.timeline({ repeat: -1 });

                tl.to(".sub-circles circle", {
                    duration: 0.5,
                    scale: 1.5,
                    ease: "power1.inOut",
                    stagger: {
                        each: 0.2,
                        repeat: 1,
                        yoyo: true
                    }
                }).to(".sub-circles circle", {
                    duration: 0.2,
                    scale: 1,
                    ease: "power1.inOut"
                });
            }

            animateCircles();



            var image1 = document.querySelectorAll(".team-selector-illustration img:nth-of-type(3)");
            var image2 = document.querySelectorAll(".team-selector-illustration img:nth-of-type(6)");
            var image3 = document.querySelectorAll(".team-selector-illustration img:nth-of-type(2)");
            var image4 = document.querySelectorAll(".team-selector-illustration img:nth-of-type(5)");

            var tls = gsap.timeline({
                scrollTrigger: {
                    trigger: "#team-selector",
                    start: "bottom bottom", // Start the animation when the top of the SVG reaches the center of the viewport
                    toggleActions: "play none none none"
                },
            });

            tls.set(image1, {
                duration: 0,
                autoAlpha: 0
            }, "+=0.75").set(image2, {
                duration: 0,
                autoAlpha: 0
            }, "+=0.75").set(image3, {
                duration: 0,
                autoAlpha: 0
            }, "+=0.75").set(image4, {
                duration: 0,
                autoAlpha: 0
            }, "+=0.75");


        }


 const flowerSelector = document.querySelector("#flower-svg");
 if (flowerSelector) {
     // Target all the flower elements
     let flowers = document.querySelectorAll(".flower");

     flowers.forEach((flower) => {
         gsap.set(flower, { transformOrigin: "center center" });
     });

     var tl = gsap.timeline({ repeat: -1 });

     tl.to(flowers, {
         rotate: -20,
         x: -70,
         repeat: -1,
         duration: 2.0,   // Duration of the sway to the right
         ease: "power1.inOut", // Smooth easing for swaying
         yoyo: true, // Return to the initial state
         stagger: {
             amount: 0.8, // Time in seconds between the start of each sway
         },
         onRepeat: function() {
             gsap.to(flowers, {
                 duration: 1.0, // Faster movement to the left
                 ease: "elastic.out(1, 0.75)", // Smooth easing
                 yoyo: true, // Repeat back to neutral position
             });
         }
     });

     // Control the timeline progress if needed
     tl.progress(0.5);
 }






}
